import script from "./VisualizarCardQuestao.vue?vue&type=script&setup=true&lang=js"
export * from "./VisualizarCardQuestao.vue?vue&type=script&setup=true&lang=js"

import "./VisualizarCardQuestao.vue?vue&type=style&index=0&id=35eb5172&lang=css"

const __exports__ = script;

export default __exports__